export default __webpack_public_path__ + "static/media/support-group-illustration.4fb8c6da.png";